var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8791 6.37527L5.39309 11.8613C4.56709 12.6873 4.56709 14.0273 5.39309 14.8533C6.21909 15.6793 7.55909 15.6793 8.38509 14.8533L15.6171 7.62127C17.1321 6.10627 17.1321 3.65027 15.6171 2.13527C14.1021 0.620273 11.6461 0.620273 10.1311 2.13527L2.89909 9.36727C0.695094 11.5713 0.695094 15.1433 2.89909 17.3473C5.10309 19.5513 8.67509 19.5513 10.8791 17.3473L15.2681 12.9583",
    stroke: "#979797",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentLight);
export default __webpack_public_path__ + "static/media/attachment_light.8bca1e8486ec0644d725a0a155007dd1.svg";
export { ForwardRef as ReactComponent };